"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleOperand = void 0;
const market_rule_base_1 = require("./market-rule-base");
class MarketRuleOperand extends market_rule_base_1.MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.value = obj.value;
        }
    }
}
exports.MarketRuleOperand = MarketRuleOperand;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtb3BlcmFuZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9zZXJ2aWNlcy9ydWxlLWVuZ2luZS1zZXJ2aWNlL2NsYXNzZXMvbWFya2V0LXJ1bGUtb3BlcmFuZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx5REFBb0Q7QUFFcEQsTUFBc0IsaUJBQWtCLFNBQVEsaUNBQWM7SUFHMUQ7OztPQUdHO0lBQ0gsWUFBbUIsR0FBZ0M7UUFDL0MsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBRVgsSUFBSSxHQUFHLEVBQUUsQ0FBQztZQUNOLElBQUksQ0FBQyxLQUFLLEdBQUcsR0FBRyxDQUFDLEtBQU0sQ0FBQztRQUM1QixDQUFDO0lBQ0wsQ0FBQztDQUNKO0FBZEQsOENBY0MifQ==